<template>
    <div>
        <NotificationGroup group="error" position="bottom">
            <div
                class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none"
                style="z-index: 999999999"
            >
                <div class="w-full max-w-sm">
                    <Notification
                        v-slot="{ notifications, close }"
                        enter="transform ease-out duration-300 transition"
                        enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                        enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-500"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                        move="transition duration-500"
                        move-delay="delay-300"
                    >
                        <div
                            class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 p-4 border border-slate-200 dark:border-slate-700 justify-start items-start gap-3"
                            v-for="notification in notifications"
                            :key="notification.id"
                        >
                            <div class="flex items-center justify-center">
                                <Icon
                                    icon="circle-x"
                                    class="text-red-600 w-5 h-5"
                                />
                            </div>
                            <div
                                class="flex-col justify-start items-start flex text-sm grow"
                            >
                                <span class="text-slate-800 dark:text-slate-100 font-medium">
                                    {{ notification.title }}
                                </span>
                                <p
                                    class="text-slate-500 dark:text-slate-400 font-normal"
                                >{{ notification.text }}</p>
                            </div>
                            <!-- <button
                                class="flex items-center justify-center text-slate-500 hover:border-slate-300 hover:bg-slate-200 active:border-slate-300 active:bg-slate-200 focus:border-slate-200 focus:outline-slate-200 cursor-pointer"
                                @click="close(notification.id)"
                            >
                                <Icon icon="close" svgClass="w-5 h-5" />
                            </button> -->
                        </div>
                    </Notification>
                </div>
            </div>
        </NotificationGroup>

        <NotificationGroup group="success" position="bottom">
            <div
                class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none"
                style="z-index: 9999999"
            >
                <div class="w-full max-w-sm">
                    <Notification
                        v-slot="{ notifications, close }"
                        enter="transform ease-out duration-300 transition"
                        enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                        enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-500"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                        move="transition duration-500"
                        move-delay="delay-300"
                    >
                        <div
                            class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 p-4 border border-slate-200 dark:border-slate-700 justify-start items-start gap-3 pointer-events-auto"
                            v-for="notification in notifications"
                            :key="notification.id"
                        >
                            <div
                                class="flex items-center justify-center text-green-500"
                            >
                                <Icon icon="circle-check" svgClass="w-5 h-5" />
                            </div>
                            <div
                                class="flex-col justify-start items-start flex text-sm grow"
                            >
                                <span class="text-slate-800 dark:text-slate-100 font-medium">
                                    {{ notification.title }}
                                </span>
                                <p
                                    class="text-slate-500 dark:text-slate-400 font-normal"
                                >{{ notification.text }}</p>
                                <a
                                    v-if="notification.url"
                                    :href="notification.url"
                                    class="text-slate-800 dark:text-slate-100 font-medium hover:underline mt-1"
                                >
                                    {{ notification.urlLabel || 'View' }}
                                </a>
                            </div>
                            <button
                                class="flex items-center justify-center text-slate-400 hover:text-slate-600 cursor-pointer"
                                @click="close(notification.id)"
                            >
                                <Icon icon="x" svgClass="w-4 h-4" />
                            </button>
                        </div>
                    </Notification>
                </div>
            </div>
        </NotificationGroup>

        <NotificationGroup group="info" position="bottom">
            <div
                class="fixed bottom-2 right-2 flex items-start justify-end"
                style="z-index: 99999999"
            >
                <div class="w-full max-w-sm">
                    <Notification
                        v-slot="{ notifications, close }"
                        enter="transform ease-out duration-300 transition"
                        enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                        enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-500"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                        move="transition duration-500"
                        move-delay="delay-300"
                    >
                        <div
                            class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 p-4 border border-blue-500 dark:border-blue-600 justify-start items-start gap-3"
                            v-for="notification in notifications"
                            :key="notification.id"
                        >
                            <div
                                class="flex items-center justify-center text-blue-500"
                            >
                                <Icon icon="circle-check" svgClass="w-5 h-5" />
                            </div>
                            <div
                                class="flex-col justify-start items-start flex text-sm grow"
                            >
                                <span class="text-blue-800 dark:text-blue-300 font-medium">
                                    {{ notification.title }}
                                </span>
                                <p
                                    class="text-slate-500 dark:text-slate-400 font-normal"
                                >{{ notification.message }}</p>
                            </div>
                            <button
                                class="flex items-center justify-center p-1 text-blue-500 hover:border-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900 active:border-blue-300 active:bg-blue-200 dark:active:bg-blue-800 focus:border-blue-200 focus:outline-blue-200 cursor-pointer rounded"
                                @click="close(notification.id)"
                            >
                                <Icon icon="close" svgClass="w-4 h-4" />
                            </button>
                        </div>
                    </Notification>
                </div>
            </div>
        </NotificationGroup>

        <NotificationGroup group="version" position="bottom">
            <Notification
                v-slot="{ notifications }"
                enter="transform ease-out duration-300 transition"
                enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                leave="transition ease-in duration-500"
                leave-from="opacity-100"
                leave-to="opacity-0"
                move="transition duration-500"
                move-delay="delay-300"
            >
                <div
                    v-if="notifications.length > 0"
                    class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6"
                    style="z-index: 999999999"
                >
                    <div class="w-full max-w-sm">
                        <div
                            class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 p-4 border border-slate-200 dark:border-slate-700 justify-start items-start gap-3"
                            v-for="notification in notifications"
                            :key="notification.id"
                        >
                            <div
                                class="flex items-center justify-center text-orange"
                            >
                                <Icon icon="circle-check" svgClass="w-5 h-5" />
                            </div>
                            <div
                                class="flex-col justify-start items-start flex text-sm grow"
                            >
                                <p class="text-orange font-medium">
                                    {{ notification.title }}
                                </p>
                                <p
                                    class="text-slate-500 dark:text-slate-400 font-normal mb-1"
                                >{{ notification.text }}</p>
                                <a
                                    v-if="notification.url"
                                    :href="notification.url"
                                    class="text-orange hover:underline"
                                >
                                    Reload
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Notification>
        </NotificationGroup>

        <NotificationGroup group="scraping" position="bottom">
            <div
                class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none"
                style="z-index: 9999999"
            >
                <div class="w-full max-w-sm">
                    <Notification
                        v-slot="{ notifications }"
                        enter="transform ease-out duration-300 transition"
                        enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                        enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-500"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                        move="transition duration-500"
                        move-delay="delay-300"
                    >
                        <div
                            :class="[
                                'flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 p-4 justify-start items-start gap-3',
                                notification.status === 'complete' ? 'border border-green-200' : 'border border-slate-200 dark:border-slate-700'
                            ]"
                            v-for="notification in notifications"
                            :key="notification.id"
                        >
                            <div class="flex items-center justify-center shrink-0">
                                <svg
                                    v-if="notification.status !== 'complete'"
                                    class="animate-spin w-5 h-5 text-blue-500"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <Icon
                                    v-else
                                    icon="circle-check"
                                    class="text-green-500 w-5 h-5"
                                />
                            </div>
                            <div
                                class="flex-col justify-start items-start flex text-sm grow"
                            >
                                <span class="text-slate-800 dark:text-slate-100 font-medium">
                                    {{ notification.title }}
                                </span>
                                <p class="text-slate-500 dark:text-slate-400 font-normal">
                                    {{ notification.text }}
                                </p>
                            </div>
                        </div>
                    </Notification>
                </div>
            </div>
        </NotificationGroup>

        <NotificationGroup group="warning" position="bottom">
            <div
                class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6 pr-3 pointer-events-none"
                style="z-index: 9999999"
            >
                <div class="w-full max-w-sm">
                    <Notification
                        v-slot="{ notifications }"
                        enter="transform ease-out duration-300 transition"
                        enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                        enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-500"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                        move="transition duration-500"
                        move-delay="delay-300"
                    >
                        <div
                            class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 p-4 border border-slate-200 dark:border-slate-700 justify-start items-start gap-3"
                            v-for="notification in notifications"
                            :key="notification.id"
                        >
                            <div
                                class="flex items-center justify-center text-red-500"
                            >
                                <svg
                                    class="w-6 h-6 fill-current"
                                    viewBox="0 0 40 40"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z"
                                    />
                                </svg>
                            </div>
                            <div
                                class="flex-col justify-start items-start flex text-sm grow"
                            >
                                <span class="text-slate-800 dark:text-slate-100 font-medium">
                                    {{ notification.title }}
                                </span>
                                <p
                                    class="text-slate-500 dark:text-slate-400 font-normal"
                                >{{ notification.text }}</p>
                            </div>
                            <!-- <button
                                class="flex items-center justify-center text-slate-500 hover:border-slate-300 hover:bg-slate-200 active:border-slate-300 active:bg-slate-200 focus:border-slate-200 focus:outline-slate-200 cursor-pointer"
                                @click="close(notification.id)"
                            >
                                <Icon icon="close" svgClass="w-5 h-5" />
                            </button> -->
                        </div>
                    </Notification>
                </div>
            </div>
        </NotificationGroup>
    </div>
</template>
<script setup>
import Icon from '@/components/ui/icon/icon.vue';
</script>
